import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";

import global from "../../config";
import Card from "../../UI/Card";

import Header from "../Header/Header";
import "./Ingest.css";
import ContextMenu from "./ContextMenu";
import Loader from "../../UI/Loader";
import ConfirmationDialog from "../../UI/ConfirmationDialog";

export default function Ingest(props) {
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [listData, setListData] = useState({});
  const [searchText, showSearchText] = useState("");
  const [submitSearch, showSubmitSearch] = useState(false);
  const [addFormDialog, setAddFormDialog] = useState(false);

  // [Start of Context Menu Option]
  const [actionID, setActionID] = useState("");
  const [toggleActionBlock, setToggleAction] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [renameFile, setRenameFile] = useState("");

  const [title, setTitle] = useState("");

  const toggleAction = () => {
    setToggleAction(!toggleActionBlock);
  };
  const editClickHandler = () => {
    toggleAction();
    setRenameFile(actionID);
    setTitle(actionID);
  };

  const clickCancel = () => {
    setRenameFile("");
    setTitle("");
    setRenameFile("");
  };

  const deleteClickHandler = (id) => {
    setShowConfirm(true);
    toggleAction();
  };
  const clickHandler = (id) => {
    toggleAction();
    setActionID(id);
  };

  const onCancelClick = () => {
    setShowConfirm(false);
  };

  const onDeleteConfirmClick = async () => {
    const idToken = localStorage.getItem("idToken");
    const payload = {
      operation: "delete",
      key: `ingest/${actionID}`,
    };

    // console.log(payload);
    const response = await axios.post(global.apiURL + "/assets/", payload, {
      headers: { Authorization: "Bearer " + idToken },
    });

    if (response.status === 200) {
      setRenameFile("");
      setTitle("");
      setActionID("");
      getData();
      // console.log("Ingest Asset Deleted");
    }
    setShowConfirm(false);
  };

  const clickSubmit = async () => {
    setShowLoader(true);
    setRenameFile("");
    const idToken = localStorage.getItem("idToken");
    const payload = {
      operation: "rename",
      oldKey: `ingest/${actionID}`,
      newKey: `ingest/${title}`,
    };
    const response = await axios.post(global.apiURL + "/assets/", payload, {
      headers: { Authorization: "Bearer " + idToken },
    });

    if (response.status === 200) {
      getData();
      console.log("Ingest Asset Renamed");
    }
  };

  const clickSerach = () => {
    setShowLoader(true);
    showSubmitSearch(true);
  };
  const keyUpSearch = (e) => {
    if (e.target.value.length === 0 || e.key === "Enter") {
      clickSerach();
    }
  };

  const getData = async () => {
    const idToken = localStorage.getItem("idToken");

    const payLoad = { operation: "list" };
    if (idToken) {
      const response = await axios.post(global.apiURL + "/assets/", payLoad, {
        headers: { Authorization: "Bearer " + idToken },
      });
      if (response.data) {
        setListData(response.data.data);
      } else {
        navigate("/");
      }
    }
    setShowLoader(false);
    showSubmitSearch(false);
  };

  useEffect(() => {
    getData();
  }, [submitSearch]);

  // [End of Search]

  const sumOfFileSizes = (fileSizes) => {
    const sumInBytes = fileSizes;
    const bytesPerGB = 1073741824;
    const sumInGB = sumInBytes / bytesPerGB;
    return Number(sumInGB.toFixed(2));
  };

  const sumOfCreatorDuration = (durations) => {
    const sumInSeconds = durations;

    const hours = Math.floor(sumInSeconds / 3600);
    const minutes = Math.floor((sumInSeconds % 3600) / 60);

    if (hours === 0) {
      return `${minutes} mins`;
    } else {
      return `${hours} hrs ${minutes} mins`;
    }
  };

  const convertDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const txtValue = (e) => {
    if (e.target.name === "txtTitle") {
      setTitle(e.target.value);
    }
  };
  const renderData = (data, serial) => {
    // List Template
    return (
      <Card>
        <div className="card-column">{serial - 1}</div>
        <div className="card-column-large">{data.Key}</div>

        <div className="card-column">{sumOfFileSizes(data.Size)}GB</div>
        {/* <div className="card-column">{data.StorageClass}</div> */}
        <div className="card-column">{data.ContentType}</div>
        <div className="card-column">{convertDate(data.LastModified)}</div>
        <div>
          <button
            className="action-button"
            type="button"
            onClick={() => clickHandler(data.Key)}
          >
            <i className="learning-icon icon-more">&#xe902;</i>
          </button>
        </div>
        {actionID === data.Key && toggleActionBlock === true && (
          <ContextMenu
            id={data.Key}
            onEditClick={editClickHandler}
            onDeleteClick={deleteClickHandler}
          />
        )}
      </Card>
    );
  };

  return (
    <>
      <div className="wrap-over-container">
        <Header />
        {showConfirm === true && (
          <ConfirmationDialog
            title="Delete the Ingest Asset"
            description="Are you sure you want to delete?"
            onCancelClick={onCancelClick}
            onSubmitClick={onDeleteConfirmClick}
            submitButtonText="Delete"
            cancelButtonText="Cancel"
          />
        )}

        <div className="admin-body">
          <div className="container">
            <div className="admin-panel">
              <div className="adheader">
                <h3>Ingest To Correct</h3>
                <div className="admin-panel-header-right"></div>
              </div>
              <div className="adbody">
                {showLoader === true && (
                  <div style={{ height: "70vh", position: "relative" }}>
                    <Loader />
                  </div>
                )}

                {renameFile && (
                  <Card>
                    <div className="card-column add-dialog-form-group ingest-edit-area">
                      <input
                        type="text"
                        onChange={txtValue}
                        name="txtTitle"
                        id="txtTitle"
                        placeholder="Enter Title"
                        value={title}
                      />
                    </div>
                    <div className="add-dialog-form-group">
                      <button
                        type="button"
                        className="add-dialog-submit"
                        onClick={clickSubmit}
                      >
                        Submit
                      </button>
                    </div>
                    <div className="add-dialog-form-group">&nbsp;</div>
                    <div className="add-dialog-form-group">
                      <button
                        type="button"
                        className="add-dialog-cancel"
                        onClick={clickCancel}
                      >
                        Cancel
                      </button>
                    </div>
                  </Card>
                )}

                {showLoader === false && (
                  <>
                    <Card type="header">
                      <div className="card-column">#</div>
                      <div className="card-column-large">ASSET NAME</div>
                      <div className="card-column">SIZE</div>
                      {/* <div className="card-column">STORAGE CLASS</div> */}
                      <div className="card-column">CONTENT TYPE</div>
                      <div className="card-column">MODIFIED DATE</div>
                      <div className="card-column-auto">Action</div>
                    </Card>
                    {listData.map((data, index) => {
                      if (data.Key === "ingest/") {
                        return null; // Skip the 'ingest/' folder itself
                      }
                      data.Key = data.Key.replace("ingest/", ""); // Remove 'ingest/' from the key
                      return (
                        <div key={data.ETag}>{renderData(data, index + 1)}</div>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
